import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseGoalTermFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_GOAL_TERM_INTRODUCTION_ID = 'gh-goal-term-introduction';

const GreenhouseGoalTermIntroduction = () => {
  const { control, getValues } = useGreenhouseForm();
  const { introduction } =
    getValues(`greenhouseGoalTerm`) ?? ({} as IGreenhouseGoalTermFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const ghGoalTermIntroductionEl = document.getElementById(
    GH_GOAL_TERM_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'greenhouseGoalTerm',
      control,
    }) ?? ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        ghGoalTermIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกระยะสั้น (short term) และ/หรือระยะยาว (long term)"
              setOpen={open}
              fieldPath="greenhouseGoalTerm.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalTermIntroductionEl
        )}
    </>
  );
};

export default GreenhouseGoalTermIntroduction;
